import React from 'react';
import SvgHome from '@/assets/svg/404/home.svg';
import SvgLightbulb from '@/assets/svg/404/lightbulb.svg';
import SvgPaintbrush from '@/assets/svg/404/paintbrush.svg';
import SvgIllustration from '@/assets/svg/404/404_v2.svg';
import Link from 'next/link';

interface INotFoundCountent {
  statusCode: number;
}

const links = [
  {
    title: 'Our Story',
    href: '/our-story',
    icon: (
      <SvgLightbulb
        viewBox="0 0 16 16"
        className="my-1.5 block h-5 w-5 *:fill-clayton-blue"
      />
    ),
  },
  {
    title: 'Our Brand Partners',
    href: '/our-brand-partners',
    icon: (
      <SvgPaintbrush
        viewBox="0 0 16 16"
        className="my-1.5 block h-5 w-5 *:fill-clayton-blue"
      />
    ),
  },
  {
    title: 'About Us',
    href: '/about',
    icon: (
      <SvgHome
        viewBox="0 0 16 16"
        className="my-1.5 block h-5 w-5 *:fill-clayton-blue"
      />
    ),
  },
];

const NotFoundContent = ({ statusCode }: INotFoundCountent) => {
  return (
    <div>
      <div className="mx-auto mt-[30px] w-mobile max-w-screen-compactTablet md:max-w-screen-lgDesktop smDesktop:mt-[105px] smDesktop:flex smDesktop:h-[486px] smDesktop:flex-row smDesktop:justify-between">
        <div className="text-center smDesktop:w-[400px]">
          {statusCode === 404 && (
            <>
              <h2 className="pt-[3px] font-bold text-hbg-blue">
                Oops, nobody&apos;s home!
              </h2>
            </>
          )}
          {statusCode === 500 && (
            <>
              <h2 className="pt-[3px] font-bold text-hbg-blue">
                We&apos;re sorry!
              </h2>
              <p className="pt-[3px]">This content is currently unavailable.</p>
            </>
          )}
          <p className="pt-[3px]">Try these helpful links instead.</p>
          <div className="my-[50px] flex flex-col justify-evenly">
            {links.map((link, index) => (
              <Link
                href={link.href}
                target="_self"
                key={index}
                className="text-clayton-blue no-underline compactTablet:border compactTablet:border-b-0 compactTablet:border-solid compactTablet:border-grey-4 compactTablet:last:border-b"
              >
                <div className="flex flex-grow items-center justify-center text-center compactTablet:p-4">
                  <div className="pr-[5px] text-clayton-blue">
                    {link.icon}
                  </div>
                  {link.title}
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div>
          <SvgIllustration className="h-full w-full smDesktop:mt-[65px] smDesktop:h-[487px] smDesktop:w-[500px] smDesktop:pl-[60px] mdDesktop:mt-[50px] mdDesktop:w-[600px] lgDesktop:mt-0 lgDesktop:w-[700px]" />
        </div>
      </div>
    </div>
  );
};

export default NotFoundContent;
